import { Component, OnInit, ViewChild, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs/Subscription";
import { QuizAnswerClass, QuizClass, QuizQuestionClass } from "../quiz.class";
import { T2CardComponent } from "app/trip2-theme/components/t2-card/t2-card.component";
import { QuizService } from "../quiz.service";
import { SweetAlertHelper } from "app/core/helpers/sweet-alert-helper.service";

@Component({
  selector: "app-create-quiz",
  templateUrl: "./create-quiz.component.html",
  styleUrls: ["./create-quiz.component.scss"],
})
export class CreateQuizComponent implements OnInit, OnDestroy {
  @ViewChild("questionModal") private questionModal: T2CardComponent;
  @ViewChild("answerModal") private answerModal: T2CardComponent;

  quizClass: QuizClass;
  showQuestionForm: boolean = false;
  showAnswerForm: boolean = false;
  private isEditingQuestion: boolean = false;
  private isEditingAnswer: boolean = false;
  subscriptions: Subscription[] = [];

  constructor(
    private _serviceQuiz: QuizService,
    private sweetAlertHelper: SweetAlertHelper
  ) {}

  get quizTitle(): string {
    if (this.quizClass && this.quizClass.quizid && this.quizClass.description) {
      return "Edit Quiz: " + this.quizClass.description;
    }
    return "Create Quiz";
  }

  get quizClassId(): boolean {
    return !!(this.quizClass && this.quizClass.quizid);
  }

  get questionModalTitle(): string {
    return this.isEditingQuestion ? 'Edit question' : 'New question';
  }

  get answerModalTitle(): string {
    return this.isEditingAnswer ? 'Edit Answer' : 'New Answer';
  }

  ngOnInit() {
    this.quizClass = new QuizClass();
    this.subscriptions.push(
      this._serviceQuiz.quizData$.subscribe({
        next: (data) => {
          this.setData(data);
        },
        error: (err) => {
          this.sweetAlertHelper.captureException(err);
        },
      })
    );
    this.subscriptions.push(
      this._serviceQuiz.questionFormSaved$.subscribe({
        next: (saved) => {
          if (saved && this.questionModal && this.questionModal.isOpen) {
            this.questionModal.close();
            this.showQuestionForm = false;
            this.isEditingQuestion = false;
          }
        },
        error: (err) => {
          this.sweetAlertHelper.captureException(err);
        },
      })
    );
    this.subscriptions.push(
      this._serviceQuiz.answerFormSaved$.subscribe({
        next: (saved) => {
          if (saved && this.answerModal && this.answerModal.isOpen) {
            this.answerModal.close();
            this.showAnswerForm = false;
            this.isEditingAnswer = false;
          }
        },
        error: (err) => {
          this.sweetAlertHelper.captureException(err);
        },
      })
    );
  }

  private setData(val: QuizClass) {
    if (val != null && val != undefined) {
      this.quizClass = val;
    } else {
      this.quizClass = new QuizClass();
    }
  }

  onQuizMainCardEmit(ev: { isOpen: boolean }) {
    if (!ev.isOpen) {
      this._serviceQuiz.setModal(false);
    }
  }

  onQuestionModalEmit(ev: { isOpen: boolean }) {
    if (!ev.isOpen) {
      this.showQuestionForm = false;
      this.isEditingQuestion = false;
    }
  }

  onAnswerModalEmit(ev: { isOpen: boolean }) {
    if (!ev.isOpen) {
      this.showAnswerForm = false;
      this.isEditingAnswer = false;
    }
  }

  onNewQuestion() {
    this.isEditingQuestion = false;
    this.showQuestionForm = true;
    this._serviceQuiz.setQuestionFormAction({
      mode: "new",
      quizId: this.quizClass.quizid,
    });
    if (this.questionModal && !this.questionModal.isOpen) {
      this.questionModal.open();
    }
  }

  setQuestion(data: QuizQuestionClass, index: number) {
    this.isEditingQuestion = true;
    this.showQuestionForm = true;
    this._serviceQuiz.setQuestionFormAction({
      mode: "edit",
      data: data,
      index: index,
    });
    if (this.questionModal && !this.questionModal.isOpen) {
      this.questionModal.open();
    }
  }

  onNewAnswer(questionIndex: number) {
    this.isEditingAnswer = false;
    this.showAnswerForm = true;
    this._serviceQuiz.setAnswerFormAction({
      mode: "new",
      questionIndex: questionIndex,
    });
    if (this.answerModal && !this.answerModal.isOpen) {
      this.answerModal.open();
    }
  }

  setAnswer(data: QuizAnswerClass, answerIndex: number, questionIndex: number) {
    this.isEditingAnswer = true;
    this.showAnswerForm = true;
    this._serviceQuiz.setAnswerFormAction({
      mode: "edit",
      data: data,
      answerIndex: answerIndex,
      questionIndex: questionIndex,
    });
    if (this.answerModal && !this.answerModal.isOpen) {
      this.answerModal.open();
    }
  }

  trackByQuestion(index: number, question: QuizQuestionClass): number {
    return question && question.quizquestionid ? question.quizquestionid : index;
  }

  trackByAnswer(index: number, answer: QuizAnswerClass): number {
    return answer && answer.quizanswerid ? answer.quizanswerid : index;
  }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length) {
      this.subscriptions.forEach(subscription => {
        if (subscription) {
          subscription.unsubscribe();
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/quiz/create-quiz/create-quiz.component.ts